<template>
  <q-dialog v-model="confirm" persistent transition-show="fade" transition-hide="fade">
    <div class="hris-modal" style="max-width: 420px;">
      <q-form @submit="confirmHoldingTrainee">
        <div class="hris-modal-header">
          <div>
            <h2 class="hris-modal-title">Hold Trainee</h2>
            <p class="hris-modal-subtitle">Do you want to continue this action?</p>
          </div>
        </div>
        <div class="hris-modal-body">
          <q-input outlined dense color="green" v-model="reason" label="Write your reason" :rules="[formRules.required]"></q-input>
        </div>
        <div class="hris-modal-footer">
          <q-btn unelevated class="hris-q-ghost" label="Cancel" v-close-popup></q-btn>
          <q-btn unelevated class="hris-q-primary" label="Confirm" type="submit"></q-btn>
        </div>
      </q-form>
    </div>
  </q-dialog>
</template>
<script>
import axios from 'axios';
import mixins from '../../mixins';

export default {

  data() {
    return {
      confirm:false,
      id:'',
      isHold:'',
      reason:'',
    }
  },

  created(){
    this.eventHub.$on('holdEmployee', this.holdEmployee);
  },

  methods: {
   holdEmployee:function(obj){
      this.id = obj.id
      this.isHold = obj.isHold
      this.confirm = obj.status
   },

   confirmHoldingTrainee:function(){
      var formData = new FormData()
      formData.append('id',this.id);
      formData.append('isHold',this.isHold);
      formData.append('reason',this.reason);

      axios.create({
       baseURL : this.apiUrl,
       headers : {'Authorization' : `Bearer ${this.token}`}
     }).post(`/mobile/pantry/trainee/hold`,formData)
     .then((response) => {
       this.confirm = false
       this.eventHub.$emit('refreshList');
     });
   }
}
}
</script>
<style lang="css" scoped>
</style>
